/* eslint-disable no-irregular-whitespace */
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { FiShoppingCart } from 'react-icons/fi';
import { NotificationManager } from 'react-notifications';
import Slider from 'react-slick';
import RelatedProduct from '../Util/RelatedProduct/RelatedProduct';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import NavSidebar from '../Util/NavSidebar/NavSidebar';
import {
  getBuyHistory,
  addToCart,
} from '../../redux/actions/cart';

import {
  getProductList,
} from '../../redux/actions/product';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './style.css';

const keywords = ['TERRA', 'ウイルス対策', '除菌剤', '港区', '赤坂', 'TERRA FORESTA', 'TERRA COAT', '光触媒コーディング （編集済み）'];

const Product = () => {
  const accessToken = useSelector((state) => state.auth.accessToken, shallowEqual);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);
  const productList = useSelector((state) => state.product.productList, shallowEqual);
  const isBuyProduct = useSelector((state) => state.cart.isBuyProduct, shallowEqual);
  const [selectCount, setSelectCount] = useState(1);
  const [product, setProduct] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [mainImage, setMainImage] = useState('');
  const [mainImageId, setMainImageId] = useState(null);
  const [relatedProduct, setRelatedProduct] = useState([]);
  // const cartsLocal = useSelector((state) => state.cart.cartsLocal, shallowEqual);

  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const { page } = useParams();
  let link = '/product';
  let textBreadcrumb = '全ての商品';

  useEffect(() => {
    dispatch(getProductList(Number(process.env.REACT_APP_COMPANY_ID), -1, 0));
  }, [dispatch]);

  if (page === 'single') {
    link = '/single';
    textBreadcrumb = '単品';
  }

  if (page === 'subscription') {
    link = '/subscription';
    textBreadcrumb = '定期便';
  }

  const onSelect = (action) => {
    if (action === 'plus') {
      setSelectCount(selectCount + 1);
    } else {
      setSelectCount(selectCount > 1 ? selectCount - 1 : selectCount);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getBuyHistory(accessToken, 1, 0));
    }
    // return () => dispatch(getBuyHistory(accessToken, 1, 0));
  }, [accessToken, dispatch, isLoggedIn]);

  useEffect(() => {
    const temp = productList.find((n) => n.id === parseInt(id, 10)) ?? null;
    if (temp) {
      const tempImageList = [];
      let tempMainImage = '';
      if (temp.main_image) tempImageList.push({ id: 0, file_name: temp.main_image });
      tempImageList.push(...temp.images);
      if (temp.main_image) {
        tempMainImage = temp.main_image;
        setMainImageId(0);
      } else if (temp.images[0]) {
        tempMainImage = temp.images[0].file_name;
        setMainImageId(temp.images[0].id);
      }
      setMainImage(tempMainImage);
      setImageList(tempImageList);
    }
    setProduct(temp);
    if (productList.length > 0 && !temp) {
      history.push(`/${page}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, productList]);

  useEffect(() => {
    // When I don't buy タワー型噴霧器　TERRA FORESTAミスト , hidden 補充用液剤 products
    const list = productList.filter((item) => {
      if (item.product_categories[0]?.category_name === 'LP') {
        return false;
      }
      if (isLoggedIn && isBuyProduct) {
        return item.id !== product?.id;
      }
      return item.id !== product?.id && !item?.name.includes('補充用液剤');
    });
    setRelatedProduct(list);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBuyProduct, productList]);
  // eslint-disable-next-line max-len

  const clickAddToCard = () => {
    // check name contains '充用液剤'
    const productSpecial = product.name.includes('充用液剤');
    // check is there a product 「タワー型噴霧器TERRA FORESTAミスト」ミスト in the cart already?
    // const productFree = product.name.includes('タワー型噴霧器　TERRA FORESTAミスト');
    if (!isBuyProduct && productSpecial && isLoggedIn) {
      NotificationManager.error('こちらの商品の購入するためには「タワー型噴霧器　TERRA FORESTAミスト」をご購入していただく必要がございます');
      // eslint-disable-next-line no-shadow
      // eslint-disable-next-line max-len
      // } else if ((productFree && cartsLocal?.length === 0) || (cartsLocal.some((cartsLocal) => cartsLocal.name === 'タワー型噴霧器　TERRA FORESTAミスト') && productFree)) {
      //   dispatch(addToCart(product, selectCount, accessToken, isLoggedIn, page, history));
      // // eslint-disable-next-line no-shadow
      // eslint-disable-next-line max-len
      // } else if ((cartsLocal.some((cartsLocal) => cartsLocal.name === 'タワー型噴霧器　TERRA FORESTAミスト')) || productFree) {
      //   NotificationManager.error('タワー型噴霧器TERRA FORESTAミストは他の商品と一緒に購入することはできません。');
    } else {
      dispatch(addToCart(product, selectCount, accessToken, isLoggedIn, page, history));
    }
  };
  if (!product) {
    return <></>;
  }
  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>商品詳細｜株式会社TERRA</title>
      </Helmet>
      <div className="subscription">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          {textBreadcrumb}
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to={link}>{textBreadcrumb}</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>{product.name}</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container">
          <div className="row">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9">
              <div className="p-2">
                <br />
                <div className="row">
                  <div className="col-12 col-lg-6 mb-5">
                    <img src={mainImage} style={{ width: '100%' }} alt="TERRA FORESTAハンディスプレー" />
                    {/* TODO append carousel image */}
                    <Slider
                      slidesToShow={4}
                      slidesToScroll={1}
                      infinite={false}
                      adaptiveHeight
                      arrows
                      className="mt-4 product-detail-slider"
                    >
                      {
                        imageList.map((item) => (
                          <div
                            aria-hidden
                            key={item.id}
                            className={`${mainImageId === item.id && 'active'} product-detail-slider-item p-1 h-100 d-block`}
                            onClick={() => {
                              setMainImage(item.file_name);
                              setMainImageId(item.id);
                            }}
                          >
                            <img
                              src={item.file_name}
                              alt="Preview"
                              className="user-select-none w-100 h-100"
                              style={{
                                backgroundColor: 'transparent',
                                objectFit: 'contain',
                                objectPosition: 'center center',
                              }}
                            />
                          </div>
                        ))
                      }
                    </Slider>
                  </div>
                  <div className="col-12 col-lg-6">
                    <span
                      className="px-4 py-1 mt-2"
                      style={{
                        background: (product.product_categories[0]?.category_name === '定期便' || product.product_categories[0]?.category_name === 'LP') ? 'rgb(239,151,45)' : 'rgb(62,170,218)',
                        color: 'white',
                        borderRadius: '1rem',
                      }}
                    >
                      {
                        (product.product_categories[0]?.category_name === '定期便' || product.product_categories[0]?.category_name === 'LP') ? '定期便' : '単品'
                      }
                    </span>
                    <h4 className="mt-4">{product?.name}</h4>
                    {
                      product?.id?.toLocaleString() === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[0].toLocaleString()
                    || product?.id?.toLocaleString() === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[1].toLocaleString()
                        ? (
                          <h2 className="my-4">
                            初回　　：￥&nbsp;5,400
                            <br />
                            2ヶ月目以降：￥&nbsp;9,720
                          </h2>
                        )
                        : (
                          <h2 className="my-4">
                            ￥&nbsp;
                            {product?.price.toLocaleString()}
                          </h2>
                        )
                    }
                    <div className="d-flex my-4">
                      <button
                        className="btn rounded p-0"
                        style={{
                          background: 'rgb(163,193,209)',
                          color: 'white',
                          lineHeight: '2.5rem',
                          Height: '2.5rem',
                          textAlign: 'center',
                          width: '50px',
                          fontSize: '1.3rem',
                        }}
                        type="button"
                        onClick={() => onSelect('minus')}
                      >
                        -
                      </button>
                      <span
                        className="rounded mx-2"
                        style={{
                          background: 'white',
                          color: 'black',
                          lineHeight: '2.5rem',
                          Height: '2.5rem',
                          textAlign: 'center',
                          width: '70px',
                          fontSize: '1.3rem',
                        }}
                      >
                        {selectCount}
                      </span>
                      <button
                        className="btn rounded p-0 mr-3"
                        style={{
                          background: 'rgb(44,81,115)',
                          color: 'white',
                          lineHeight: '2.5rem',
                          Height: '2.5rem',
                          textAlign: 'center',
                          width: '50px',
                          fontSize: '1.3rem',
                        }}
                        type="button"
                        onClick={() => onSelect('plus')}
                      >
                        +
                      </button>
                      <button
                        className="btn rounded p-0"
                        type="button"
                        style={{
                          background: 'rgb(44,81,115)',
                          color: 'white',
                          borderRadius: '1rem',
                          lineHeight: '3rem',
                          Height: '3rem',
                          textAlign: 'center',
                          width: '220px',
                          margin: 'auto',
                        }}
                        onClick={clickAddToCard}
                      >
                        <FiShoppingCart style={{ fontSize: '1.3rem', marginRight: '15px' }} />
                        カートに追加
                      </button>
                    </div>
                    <div className="product-desc mt-5 mb-3">
                      <h5 className="my-3">商品説明</h5>
                      <div
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: product.description }}
                      />
                      {
                        product.isSubscription ? (
                          <p>
                            ※定期配送の商品です。
                            <br />
                            ※お 届 け す る 加 湿 器 は 機 種 の 変 更 等 に よ
                            り画像と異なる場合がございます。
                            <br />
                            ※初 月 に 加 湿 器 本 体 と 補 充 用 液 剤 を お 届
                            け し、以 降 は 補 充 用 液 剤 の み を お 届 け い
                            たします。
                          </p>
                        ) : ''
                      }
                    </div>
                  </div>
                </div>
                <RelatedProduct
                  productList={
                    relatedProduct.filter(
                      (p) => product.product_categories[0]?.category_name
                          === p.product_categories[0]?.category_name,
                    )
                  }
                  page={page}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Product;
